import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.wholeHouse.formula.sortFields,
	columnFields: constants.wholeHouse.formula.columnFields,
	standardFilterFields: constants.wholeHouse.formula.osStandardFilterFields,
	dateFilterFields: constants.wholeHouse.formula.osDateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
